import COUNTRY_ACTIONS from "../actions/CountriesActions";
import _ from "lodash";

const initialState = {
    country: {},
    associatedKYCData: [],
    associatedKYBData: [],
    associatedTenants: [],
}

const countryDetailReducer = (state = initialState, action) => {
    switch (action.type) {

        case COUNTRY_ACTIONS.Detail.LOAD_COUNTRY_DETAIL: {
            let newState = _.cloneDeep(state);
            newState.country = action.payload.countryDetail;
            newState.associatedKYCData = action.payload.countryDetail.kyc_services_sources;
            newState.associatedKYBData = action.payload.countryDetail.kyb_services_sources;
            newState.associatedTenants = action.payload.countryDetail.tenants;
            return newState;
        }

        case COUNTRY_ACTIONS.Detail.CLEAR_COUNTRY_DETAIL_PAGE: {
            return initialState
        }

        default: return state
    }
}

export default countryDetailReducer;
